import noop from 'lodash-es/noop';
import { getUserPreferences } from '../services/userPreferences';

/* #TODO
	* Deprecated
		* Hiddenfeatures: 
			* Remove after all user preference records have been migrated
		* RecenltyAdded:  
			* Remove after mobile has implemented user preferences and is in sync with web
		* Temporary solution - 11-02-22 JT
*/

export default {
  namespace: 'userPreferences',
  state: {
    deprecated: {
      hiddenFeatures: []
    },
    favorites: {
      icons: [],
      states: []
    },
    features: {
      visible: {
        all: true,
        features: [],
        updatedAt: null,
      },
    },
    global: {
      layer: {
        opacity: []
      },
      pinned: {
        collection: null
      },
      terrainAnalysis: {
        aspect: [1, 2, 8, 9],
        elevation: [100, 14400],
        enabled: false,
        opacity: 0.5,
        slope: [1, 2, 3, 4, 5]
      }
    },
    layers: {
      visible: [],
    },
    recents: {
      features: {
        styles: {
          points: []
        }
      },
      layers: []
    }
  },
  effects: {
    *getUserPreferencesEffect({ callback = noop }, { call, put, select }) {
      const { isRegisteredUser } = yield select((model) => model.user.profile);
      const userPreferencesState = yield select((model) => model.userPreferences)

      let userPreferences = null
      let userPreferencesRequest = yield call(getUserPreferences, { path: 'maps' })
      if (userPreferencesRequest.success && userPreferencesRequest.data) {
        userPreferences = userPreferencesRequest.data
      } else {
        userPreferences = userPreferencesState
      }

      const preferences = {
        collections: {
          pinned: userPreferences.global.pinned.collection
        },
        features: {
          favorites: {
            icons: userPreferences.favorites.icons
          },
          recents: userPreferences.recents.features,
          visible: userPreferences.features.visible
        },
        layers: {
          active: userPreferences.layers.visible,
          category: {
            opacity: userPreferences.global.layer.opacity,
          },
          favorites: {
            states: userPreferences.favorites.states
          },
          recent: userPreferences.recents.layers
        },
        terrain: {
          ...userPreferences.global.terrainAnalysis,
          enabled: false
        }
      }

      if (isRegisteredUser) {
        preferences.layers = {
          active: userPreferencesState.layers.visible,
          category: {
            opacity: userPreferencesState.global.layer.opacity,
          },
          favorites: {
            states: preferences.favorites.states
          },
          recent: userPreferencesState.recents.layers
        }
        preferences.terrain = userPreferencesState.global.terrainAnalysis
      }
      /********************************************************************************************/
      // Temp solutions
      if (!userPreferences.deprecated) {
        preferences.features.deprecated = {
          hiddenFeatures: []
        }
      } else {
        preferences.features.deprecated = {
          hiddenFeatures: userPreferences.deprecated.hiddenFeatures
        }
      }
      /********************************************************************************************/
      yield put({ type: 'collections/setAllPreferences', payload: preferences.collections })
      yield put({ type: 'features/setAllPreferences', payload: preferences.features })
      yield put({ type: 'layers/setAllPreferences', payload: preferences.layers })
      yield put({ type: 'terrain/setAllPreferences', payload: preferences.terrain })
      callback()
    },
    reducers: {}
  }
}
